import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeRhombusIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M2.34 11.96L12 2.3L21.66 11.96L12 21.62L2.34 11.96ZM4.98 11.96L12 18.98L19.02 11.96L12 4.94L4.98 11.96Z" />
    </SvgIcon>
  );
});
